import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(() => ({
  passwordResetButton: {
    marginTop: "30px",
    fontSize: 18,
    fontWeight: 600
  }
}));
